import { useSyncExternalStore } from 'react';

/**
 * Subscribed, not sampled: a hook that starts at its server default and corrects only on CHANGE never
 * corrects for a viewport that matched on load. Server snapshot `false`. Only where the answer decides
 * what is RENDERED or MEASURED; styling belongs in CSS.
 */
export function useMediaQuery(query: string): boolean {
	return useSyncExternalStore(
		(onChange) => {
			const list = window.matchMedia(query);
			list.addEventListener('change', onChange);
			return () => list.removeEventListener('change', onChange);
		},
		() => window.matchMedia(query).matches,
		() => false,
	);
}
